import { apiFetch } from "@/lib/apiClient";

export interface ContactMessage {
  name: string;
  email: string;
  subject: string;
  message: string;
  /** Which button opened the form, so the inbox can tell demo requests apart. */
  source: "demo" | "contact";
}

/**
 * Public, no sign-in: the backend emails the message to the MedSyncIQ inbox
 * (admin@medsync.com) with the visitor's address as Reply-To.
 * 202 · 400 VALIDATION_ERROR · 429 RATE_LIMITED
 */
export async function sendContactMessageApi(body: ContactMessage) {
  const { error } = await apiFetch<{ message?: string }>("/api/v1/public/contact", {
    method: "POST",
    body: JSON.stringify(body),
    skipAuth: true,
  });
  return { error: error?.message ?? null };
}
